import { Manager } from '../Manager';
import { MapActions, MapEmitter } from './MapEmitter';
import { MapChest } from '../../UI/Map/MapChest';
import Core from '../../Core/Core';
import { AllMapChests, IMapChests, MapChestsStates } from '../../Config/MapChests';
import { Actions } from '../../State/Actions/Actions';
import { IRewardItem, replaceBlockedItem, storeRewards } from '../../State/reducers/score';
import { getCollectionInProgress, getCollectionProgress } from '../../Utils/CollectableUtils';
import { TGameAreas, TransactionActionTypes } from '../../DeltaTracking/ResourceParamBuilder';
import ResourceTracking from '../Tracking/ResourceTracking';
import { StateUtils } from '../StateUtils';
import { MapList, NODES_PER_MAP } from '../../Config/Levels';
import { HudActions, HudEmitter } from '../Hud/HudEmitter';

export default class MapChests extends Manager {
    constructor() {
        super();
        const { StatePlayer: player } = Core.store.getState();
        this.initChests(AllMapChests[player.mapId]);
        MapEmitter.instance.on(MapActions.CHEST_SELECT, this.handleChestSelect);
    }

    public cleanUp() {
        MapEmitter.instance.off(MapActions.CHEST_SELECT, this.handleChestSelect);
        super.cleanUp();
    }

    private async handleChestSelect(chest: MapChest) {
        const {
            StatePlayer: { unlockedChests },
        } = Core.store.getState();
        if (unlockedChests[chest.chests.index] === MapChestsStates.LOCKED) {
            chest.showClosedAnimation();
            return;
        }

        Core.store.dispatch(Actions.changeChestState([chest.chests.index, MapChestsStates.OPENED]));

        const reward: IRewardItem[] = [];
        chest.chests.content.forEach(current => {
            reward.push(replaceBlockedItem(current));
        });

        const collectionInProgress = getCollectionInProgress();
        const collectionProgress = getCollectionProgress(collectionInProgress);
        await chest.openAnimation(reward, collectionInProgress, collectionProgress);
        storeRewards(reward, TransactionActionTypes.MAP_CHEST);
        reward.forEach(r => {
            ResourceTracking.sendRewardResourceEvent(
                r.id.toLowerCase(),
                r.val as number,
                TransactionActionTypes.MAP_CHEST,
                TGameAreas.MAP
            );
        });

        HudEmitter.instance.emit(HudActions.SHOW_CURR_ADDS);
    }

    /**
     * init chests, add and unlock as needed
     * @param mapChests
     */
    private initChests(mapChests: IMapChests[]) {
        const { StatePlayer: player } = Core.store.getState();
        const { unlockedChests, lastLevelIndex: lastLevel } = player;
        mapChests.forEach(element => {
            while (element.index > unlockedChests.length - 1) {
                Core.store.dispatch(Actions.addChest());
            }
            const hasStars =
                StateUtils.getStarsForLevel(
                    player,
                    element.levelNum - MapList.indexOf(player.mapId) * NODES_PER_MAP
                ) > 0;
            const unlocked = lastLevel >= element.levelNum && hasStars;
            if (unlocked && unlockedChests[element.index] !== MapChestsStates.OPENED) {
                Core.store.dispatch(
                    Actions.changeChestState([element.index, MapChestsStates.UNLOCKED])
                );
            }
        });
    }
}
